import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import SmartOrg from "./smart-org/smartOrg.vue";
import { StaffSelectorBase } from "../staff-selector-base";
let StaffSelector = class StaffSelector extends StaffSelectorBase {
    get SearchPlaceholder() {
        let output = "";
        if (this.options.selectOrg) {
            // output = "搜索组织";
            output = 'SearchOrg';
        }
        if (this.options.selectUser) {
            // output = "搜索姓名/账号";
            output = 'SearchNameAccount';
        }
        if (this.options.selectOrg && this.options.selectUser) {
            // output = "搜索组织、姓名";
            output = 'SearchOrgUserRole';
        }
        return output;
    }
    treeFocus() {
        super.treeFocus();
    }
    // 树-返回
    onClickTrunBack() {
        super.onClickTrunBack();
    }
    // 树-下一级
    onClickNextHierarchy(val) {
        super.onClickNextHierarchy(val);
    }
    onClickBreadcrumb(val) {
        super.onClickBreadcrumb(val);
    }
    onChange(items) {
        super.onChange(items);
    }
    onOk(items) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            _super("onOk").call(this, items);
        });
    }
    onCancle() {
        super.onCancle();
    }
    onSearch(name) {
        super.onSearch(name);
    }
};
StaffSelector = tslib_1.__decorate([
    Component({
        name: "staff-selector",
        components: {
            SmartOrg,
        },
        model: {
            event: "change",
            prop: "value",
        },
    })
], StaffSelector);
export default StaffSelector;
